export const setShortCode = (shortCode) => {
    localStorage.setItem('short_code', shortCode);
};